import { Button, Card, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
// import ProductFilterScreen from "./ProductFilterScreen";
import {
  HEADER_TEXT,
  NO_RESULT_FOUND_TEXT,
  RECOMMENDED_TEXT,
  RESULTS,
  SORT_BY,
  START_OVER,
  SortingTypes,
  VIEW_DETAILS,
} from "../utils/constants";
import { FireAnalyticsEvent, FireTealiumEvent } from "../utils/events";

function ResultScreen(props) {
  const { products, endQuiz, filters, quizData } = props;
  const [selectedSortType, setSelectedSortType] = useState(
    "Price (low to high)"
  );

  // We cannot set default value to 0 otherwise it will by default show view product button on 1st product card
  const [hoverProductCardIndex, setHoverProductCardIndex] = useState("");
  const [updatedProducts, setUpdatedProducts] = useState();

  // Get question and answer list and convert it to lowercase to pass in the tealium event
  const questionList = quizData.to_pass.qa_hist
    .filter((qa) => typeof qa === "string")
    .map((question) => question.toLowerCase());
  const answerList = quizData.to_pass.qa_hist
    .filter((qa) => typeof qa === "object")
    .map((answers) => answers.map((ans) => ans.toLowerCase()));

  // Use to pass user id and device id related data to tealium event
  const userDetailsForTealiumEvents =
    JSON.parse(localStorage.getItem("DSOTF_LOGIN_HINT_KEY")) || {};

  useEffect(() => {
    // on the first time, display product by low to high price
    const sortedProducts = sortByKey(products, "selling_price", 0);

    setUpdatedProducts(sortedProducts);
    // Google Analytics event
    FireAnalyticsEvent("guideVBAComplete", {
      guideVBAQuizType: "haircare",
      guideVBAQuizTotalProducts: sortedProducts.length,
    });

    let item_position = [],
      product_id = [],
      product_name = [],
      product_brand = [],
      product_sku = [],
      product_category = [],
      product_category_1 = [],
      product_category_2 = [],
      product_category_3 = [],
      product_price = [],
      product_sale_price = [];

    products?.forEach((product, index) => {
      item_position.push(`${index + 1}`);
      product_id.push(product.product_id);
      product_name.push(product.product_name.toLowerCase());
      product_brand.push(product.brand.toLowerCase());
      product_sku.push(product.sku);
      product_category.push(
        `${product.cat_name_tier1[0].toLowerCase()}:${product.cat_name_tier2[0].toLowerCase()}:${product.cat_name_tier3[0].toLowerCase()}`
      );
      product_category_1.push(product?.cat_name_tier1[0].toLowerCase());
      product_category_2.push(product?.cat_name_tier2[0].toLowerCase());
      product_category_3.push(product?.cat_name_tier3[0].toLowerCase());
      product_price.push(product.selling_price);
      product_sale_price.push(product.on_sale_price);
    });
    const impressionEventPayload = {
      page_name: "haircare quiz",
      page_group: "discover",
      page_type: "marketing",
      user_gtid: userDetailsForTealiumEvents.gti,
      user_gtid_known: userDetailsForTealiumEvents.gti,
      user_gtid_device: userDetailsForTealiumEvents.retailerVisitorId,
      results: products.length || 0,
      beauty_quiz_type: "haircare",
      skin_advisor_filter_sort: selectedSortType.toLowerCase(),
      beauty_quiz_questions_list: questionList,
      beauty_quiz_response_list: answerList,
      item_position,
      product_id,
      product_name,
      product_brand,
      product_sku,
      product_category,
      product_category_1,
      product_category_2,
      product_category_3,
      product_price,
      product_sale_price,
      tealium_event: "quiz_complete",
    };

    FireTealiumEvent(null, impressionEventPayload, true);
  }, []);

  const filterProductsData = (data) => {
    setUpdatedProducts(data.products || []);
  };

  const sortByKey = (products, key, order) => {
    return products.sort((a, b) => {
      const x = a[key];
      const y = b[key];
      return order === 0 ? x - y : y - x;
    });
  };

  const handleSortingTypeChange = (event) => {
    const {
      target: { value },
    } = event;
    let sortValue = value;
    let order;
    if (sortValue === "Price (low to high)") {
      sortValue = "selling_price";
      order = 0;
    } else if (sortValue === "Price (high to low)") {
      sortValue = "selling_price";
      order = 1;
    }
    const sortedProducts = sortByKey(updatedProducts, sortValue, order);

    setUpdatedProducts(sortedProducts);
    setSelectedSortType(value);

    const eventPayload = {
      page_name: "haircare quiz",
      page_group: "discover",
      page_type: "marketing",
      user_gtid: userDetailsForTealiumEvents.gti,
      user_gtid_known: userDetailsForTealiumEvents.gti,
      user_gtid_device: userDetailsForTealiumEvents.retailerVisitorId,
      sort_label: value.toLowerCase(),
      results: products.length || 0,
      tealium_event: "component_click",
    };
    FireTealiumEvent(null, eventPayload);
  };

  const handleProductCardClick = (product, index) => {
    window.open(
      `https://www.ulta.com/p?productId=${product.product_id}`,
      "_self"
    );

    const eventPayload = {
      page_name: "haircare quiz",
      page_group: "discover",
      page_type: "marketing",
      user_gtid: userDetailsForTealiumEvents.gti,
      user_gtid_known: userDetailsForTealiumEvents.gti,
      user_gtid_device: userDetailsForTealiumEvents.retailerVisitorId,
      results: products.length || 0,
      beauty_quiz_type: "haircare",
      action_detail: "view details",
      action_type: "link",
      item_position: [`${index + 1}`],
      skin_advisor_filter_sort: selectedSortType.toLowerCase(),
      beauty_quiz_questions_list: questionList,
      beauty_quiz_response_list: answerList,
      product_id: [product.product_id],
      product_sku: [product.sku],
      product_name: [product.product_name.toLowerCase()],
      product_brand: [product.brand.toLowerCase()],
      product_category: [
        `${product.cat_name_tier1[0].toLowerCase()}:${product.cat_name_tier2[0].toLowerCase()}:${product.cat_name_tier3[0].toLowerCase()}`,
      ],
      product_category_1: [product?.cat_name_tier1[0].toLowerCase()],
      product_category_2: [product?.cat_name_tier2[0].toLowerCase()],
      product_category_3: [product?.cat_name_tier3[0].toLowerCase()],
      product_price: [product.selling_price],
      product_sale_price: [product.on_sale_price],
      tealium_event: "select_item",
    };
    FireTealiumEvent(null, eventPayload);
  };

  return (
    <div className="white-background">
      {updatedProducts?.length === 0 ? (
        <>
          <div className="d-flex justify-content-center align-items-center flex-column py-5 result-screen-bg-image">
            <div className="mb-3 text-uppercase fw-normal">{HEADER_TEXT}</div>
            <p className="text-center fw-bold fs-5 mb-4">{RECOMMENDED_TEXT}</p>
            <Button
              variant="text"
              className="text-black fw-bold"
              onClick={endQuiz}
            >
              {START_OVER}
            </Button>
            <div className="text-center fw-bold fs-5 mb-4">0 {RESULTS}</div>
            <div className="text-center pt-4 custom-margin">
              {NO_RESULT_FOUND_TEXT}
            </div>
          </div>
          {/* <ProductFilterScreen
            filters={filters}
            filterProductsData={filterProductsData}
          /> */}
        </>
      ) : (
        <>
          <div className="d-flex justify-content-center align-items-center flex-column py-5 result-screen-bg-image">
            <div className="mb-3 text-uppercase fw-normal">{HEADER_TEXT}</div>

            <p
              id="resultsDescription"
              className="text-center fw-bold fs-5 mb-4"
            >
              {RECOMMENDED_TEXT}
            </p>
            <Button
              variant="text"
              className="text-black fw-bold"
              onClick={endQuiz}
            >
              {START_OVER}
            </Button>
          </div>
          {/* <ProductFilterScreen
            filters={filters}
            filterProductsData={filterProductsData}
          /> */}
          <div className="d-flex flex-column">
            <div className="d-flex justify-content-between mx-5 my-4">
              <Typography className="fw-bold" variant="h5">
                {updatedProducts?.length} {RESULTS}
              </Typography>
              <div>
                <Typography className="fw-bold" variant="h6">
                  {SORT_BY}
                </Typography>
                <select onChange={handleSortingTypeChange} className="d-flex">
                  {SortingTypes.map((type, index) => (
                    <option
                      key={index}
                      value={type}
                      selected={selectedSortType === type}
                    >
                      {type}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="d-flex flex-wrap mx-3 justify-content-center">
              {updatedProducts?.map((product, index) => (
                <Card
                  className="p-3 product-card"
                  onMouseEnter={(e) => {
                    setHoverProductCardIndex(index);
                  }}
                  onMouseLeave={(e) => {
                    setHoverProductCardIndex("");
                  }}
                  key={index}
                >
                  <img
                    className="product-image"
                    src={`${product.product_image}?fmt=auto`}
                    alt="product details"
                  />
                  <Button
                    variant="contained"
                    onClick={() => handleProductCardClick(product, index)}
                    className={`${
                      hoverProductCardIndex === index ? "d-block" : "d-none"
                    } view-details text-capitalize fw-bold`}
                  >
                    {VIEW_DETAILS}
                  </Button>
                  <div className="d-flex justify-content-center align-items-center flex-column">
                    <div className="text-center fw-bold">{product.brand}</div>

                    <div className="text-center">{product.product_name}</div>
                    <Typography className="fw-bold">
                      {"$" + parseFloat(product.selling_price).toFixed(2)}
                    </Typography>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default ResultScreen;
